import axios from "@/config/axios";
 
const initialState = () => {
  return {
    isRejectTestLoading: false,
  }
}

const state = initialState()
 
const getters = {
  isRejectTestLoading: (state) => state.isRejectTestLoading,
};
 
const mutations = {
  SET_LOADING(state, status) {
    state.isRejectTestLoading = status;
  },
  reset(state) {
    const initial = initialState();
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key];
    });
  },
};
 
const actions = {
  createCCRCase: async ({ commit, dispatch }, params) => {
    try {
      commit("SET_LOADING", true);

      let payload;
      let config = {};

      if (params.image instanceof File) {
        const formData = new FormData();
        formData.append("image", params.image);
        formData.append("case_id", params.case_id);
        formData.append("panels", JSON.stringify(params.panels));
        formData.append("tests_info", JSON.stringify(params.tests_info));
        formData.append("notes", params.notes || "");
        formData.append("reasons", JSON.stringify(params.reasons));
        payload = formData;
        config = { headers: { "Content-Type": "multipart/form-data" } };
      } else {
        payload = params;
      }

      const response = await axios.post("cases/create-ccr-case", payload, config);
      return response.data;

    } catch (error) {
      if (error.response) {
        await dispatch("errors/errorResponse", error.response, { root: true });
      }
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },
};
 
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
 
 